







import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system/mixins";
import { OptionDropDownSelector } from "../../../../system/selectors";
import { StandardOption } from "../../../../system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class DocumentScaleSelector extends Mixins(ModelEditableMixin) {
  @Prop()
  scales: number[];

  get options(): StandardOption<number>[] {
    return (this.scales ? this.scales : []).map(s => new StandardOption<number>(`${Math.round(s * 100)}%`, s));
  }
}
